/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React, { useEffect } from 'react';
import anime from 'animejs';
import LanguageIcon from '@mui/icons-material/Language';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WebIcon from '@mui/icons-material/Web';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import VideocamIcon from '@mui/icons-material/Videocam';
import CameraIcon from '@mui/icons-material/Camera';
import CameraRearIcon from '@mui/icons-material/CameraRear';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import {  useInView } from "framer-motion";
import { useRef } from "react";
import couvertureImg from '../../images/services.jpg'
import Footer from '../../Components/Footer';
import ScrollToTop from '../../Components/scrollup'
export default function Services() {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  const isInView2 = useInView(ref2, { once: true });
  const isInView3 = useInView(ref3, { once: true });
  useEffect(() => {
    anime({
      targets: ".refImg",
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(200, { start: 300 }),
      easing: "easeInOutQuad",
    });

  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".refImg:not(.vide)");
    anime({
      targets: elements,
      translateX: [400, 0],
      opacity: [0, 1],
      scale: [0, 1],
      delay: anime.stagger(300, { start: 400 }),
      easing: "easeInOutQuad",
    });
  }, []);

  return (
      <div className='projets'>
        <ScrollToTop/>
        <img src={couvertureImg} alt="couverture" className='serviCecoverImg' />
        <div className='nosProjets'>
        <h2>Nos Services</h2>
        <p>Notre agence vous propose plusieurs services pour vous aider à développer votre présence en ligne. Nous créons des sites web adaptés à vos besoins, faciles à utiliser et professionnels. Nous offrons également des services de design graphique, pour créer des logos, des affiches, et tout ce dont vous avez besoin pour représenter votre entreprise. Nous produisons aussi des vidéos et des contenus audiovisuels pour mettre en valeur votre entreprise et attirer l’attention de vos clients. Enfin, nous proposons des services de photographie pour capturer des images professionnelles et sublimer vos produits</p>
        <div className='serviceDetails'>
       <div className='serviceDetail' ref={ref1} style={{ 
            transform: isInView1 ? "none" : "translateY(200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
          }}>
        <h4>Création site Web</h4>
        <p>Nous créons des sites web modernes et faciles à utiliser, en utilisant les dernières technologies. Que ce soit pour un site vitrine, un e-commerce ou un site personnalisé, nous vous offrons un design adapté à vos besoins et une navigation fluide, pour que votre site soit accessible sur tous les appareils.</p>
        <div className='serviceDescreptions'>
        <div className='serviceDescreption'>
          <LanguageIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Site Vitrine</p>
<p>La création d’un site web vitrine allie esthétique et clarté pour présenter efficacement les produits ou services d’une entreprise en ligne</p>
        </div>
        <div className='serviceDescreption'>
          <ShoppingCartIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}} >Site E-Commerce</p>
<p>Le site web e-commerce permet aux entreprises de réaliser des ventes en ligne et de gagner de nouveaux clients 100% digital</p>
        </div>
        <div className='serviceDescreption'>
          <WebIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Site sur Mesure</p>
<p>Un site web sur mesure nécessite un étude particulier et un développement web natif </p>
        </div>
        
        </div>
       </div>
       <div className='serviceDetail' ref={ref2} style={{ 
            transform: isInView2 ? "none" : "translateY(200px)",
            opacity: isInView2 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
          }}>
        <h4>Création de contenu</h4>
     
        <div className='serviceDescreptions'>
        <div className='serviceDescreption'>
          <AddAPhotoIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Photographie de Produit (Packshot)</p>
<p>Mettez vos produits en valeur avec des images d'une qualité exceptionnelle, idéales pour vos catalogues, e-commerce et réseaux sociaux.</p>
        </div>
        <div className='serviceDescreption'>
          <CameraIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Photographie d'Ambiance</p>
<p>Offrez une dimension émotionnelle à vos produits grâce à des mises en scène captivantes qui racontent leur histoire et séduisent vos clients.</p>
        </div>
        <div className='serviceDescreption'>
          <VideocamIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Production Vidéographieque</p>
<p > Créez des vidéos percutantes pour présenter vos produits, leurs fonctionnalités et leur valeur ajoutée de manière engageante</p>
        </div>
        <div className='serviceDescreption'>
          <CameraRearIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Storytelling Visuel</p>
<p>Faites parler votre marque! Nous concevons des récits visuels authentiques et mémorables pour renforcer votre image et toucher votre audience</p>
        </div>
        
        </div>
       </div>
       <div className='serviceDetail' ref={ref3} style={{ 
            transform: isInView3 ? "none" : "translateY(200px)",
            opacity: isInView3 ? 1 : 0,
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
          }}>
        <h4 >Nos Services design graphique et SEO</h4>
     
        <div className='serviceDescreptions'>
        <div className='serviceDescreption'>
          <DesignServicesIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Design graphique</p>
<p>Le design graphique est l’art de la conception visuelle réalisé par des designers expérimentés. Nous offrons à nos clients un service graphique complet</p>
        </div>
        <div className='serviceDescreption'>
          <TravelExploreIcon fontSize='large' style={{color:'#313131'}}/>
        <p style={{color:'#313131',fontWeight:'bold'}}>Referencement naturel</p>
<p>Notre service de SEO optimise votre site pour améliorer son positionnement sur les moteurs de recherche et attirer plus de trafic qualifié.</p>
        </div>
        </div>
       </div>
         </div>
        </div>
        <Footer/>
      </div>
    
    
  );
}


